import React from 'react';

/**
 * ErrorBoundary (Tier 4.1)
 *
 * Prevents a crash in one component from blanking the entire page.
 * Usage:
 *   <ErrorBoundary>
 *     <SomeComponent />
 *   </ErrorBoundary>
 *
 *   // Custom fallback:
 *   <ErrorBoundary fallback={<p>Could not load this section.</p>}>
 *     <SomeComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught error:', error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div style={{
          padding: '24px',
          margin: '16px',
          border: '1px solid #fca5a5',
          borderRadius: '8px',
          background: '#fef2f2',
          textAlign: 'center',
        }}>
          <p style={{ color: '#dc2626', fontWeight: 600, marginBottom: '8px' }}>
            Something went wrong
          </p>
          <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '16px' }}>
            Refresh the page or click below to retry this section.
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '8px 16px',
              background: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
